import * as React from "react";
import pdf from "@react-pdf/renderer";
import IndexesByCategoryDataReportPDF from "./IndexesByCategoryDataReportPDF";
import {
  IIndexHarmonizationReport,
  TIndexHarmonizationReport
} from "../../model/IndexHarmonizationReport";

import { IOrganisationIndexCategory } from "../../../organisations/model/OrganisationIndexCategory";

const { Document, StyleSheet, Font } = pdf;
const IndexesByCategoryDataReportPDFTemplate = ({
  translate,
  data,
  title,
  subtitle,
  date,
  selectedCategory
}: {
  translate?: any;
  data?: TIndexHarmonizationReport[];
  title?: string;
  subtitle?: string;
  date?: Date;
  selectedCategory?: IOrganisationIndexCategory;
}) => {
  const renderData = () => {
    let renderedApplicants: JSX.Element[] = [];
    data?.forEach((item: IIndexHarmonizationReport) => {
      renderedApplicants.push(
        <IndexesByCategoryDataReportPDF
          translate={translate}
          styles={styles}
          data={item}
          category={selectedCategory}
          date={date}
        />
      );
    });
    return renderedApplicants;
  };
  return <Document title={subtitle}>{renderData()}</Document>;
};

export default IndexesByCategoryDataReportPDFTemplate;

Font.register({
  family: "Segoe UI",
  fonts: [
    {
      family: "Segoe UI",
      src: "//db.onlinewebfonts.com/t/623c7118249e082fe87a78e08506cb4b.ttf"
    }
  ]
});
const styles = StyleSheet.create({
  body: {
    padding: "37pt 37pt 37pt 68pt"
  },
  title: {
    fontSize: "14pt",
    height: "20pt",
    padding: "0pt 5pt 0pt 5pt",
    fontFamily: "Segoe UI"
  },
  subtitle: {
    fontSize: "8pt",
    padding: "0pt 5pt 0pt",
    fontFamily: "Segoe UI"
  },
  hierarchyGroups: {
    fontSize: 8,
    padding: "0pt 5pt 0pt",
    fontFamily: "Segoe UI"
  },
  hierarchyItem: {
    fontSize: 10,
    fontFamily: "Segoe UI",
    padding: "0pt 5pt 0pt"
  },
  arrowStyle: {
    fontSize: 8,
    fontFamily: "Segoe UI"
  },
  pageNumbers: {
    fontSize: 10,
    fontFamily: "Segoe UI",
    position: "absolute",
    bottom: "25pt",
    right: "37pt"
  }
});
